import { IAction } from "@Interfaces/common";
import ActionType from "@Actions/Login/action-types";
import { fromJS } from "immutable";

const initialState = fromJS({
  type: null,
  isLoading: false,
  isFetched: false,
  payload: null,
  error: null,
  profile: null,
});
export default (state: any = initialState, action: IAction) => {
  switch (action.type) {
    case ActionType.LOGIN_START:
    case ActionType.GET_PROFILE_START:
    case ActionType.LOGOUT_START:
      return state
        .set("type", fromJS(action.type))
        .set("isLoading", true)
        .set("isFetched", false)
        .set("error", null);
    case ActionType.LOGIN_SUCCESS:
    case ActionType.LOGOUT_SUCCESS:
      return state
        .set("type", fromJS(action.type))
        .set("isLoading", false)
        .set("isFetched", true)
        .set("payload", fromJS(action.payload))
        .set("error", null)
        .set("profile");
    case ActionType.GET_PROFILE_SUCCESS:
      return state
        .set("type", fromJS(action.type))
        .set("isLoading", false)
        .set("isFetched", true)
        .set("profile", fromJS(action.payload))
        .set("error", null);
    case ActionType.LOGIN_ERROR:
    case ActionType.GET_PROFILE_ERROR:
    case ActionType.LOGOUT_ERROR:
      return state
        .set("type", fromJS(action.type))
        .set("isLoading", false)
        .set("isFetched", false)
        .set("error", fromJS(action.error));
    default:
      return state;
  }
};
